import { Box, Button, Divider, Typography } from "@mui/material";
import clsx from "clsx";
import React from "react";
import { makeStyles } from "@mui/styles";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  root: {
    "& li": {
      paddingRight: "40px",
    },
  },
}));

export default function ConfirmMeeting(props) {
  const classes = useStyles(props);
  const { reviewDate } = props;
  const dateFormat = moment(reviewDate?.scheduledStartDate).format(
    "MMMM Do YYYY"
  );
  const startTime = moment(reviewDate?.scheduledStartDate).format("hh:mm A");
  const endTime = moment(reviewDate?.scheduledEndDate).format("hh:mm A");
  let weekDayName = moment(reviewDate?.scheduledEndDate).format("dddd");
  // console.log('dateFormat : ', logTimeIn)
  // const { scheduledStartDate } = reviewDate;

  return (
    <div className={clsx(classes.root, "my-24")}>
      <Typography variant="subtitle1">
        Confirm Meeting for Site Visit
      </Typography>
      <Divider sx={{ my: 2 }} />
      <ul className="flex">
        <li className="flex items-center">
          <FuseSvgIcon size={40}>heroicons-outline:calendar</FuseSvgIcon>
          <Box sx={{ ml: 2 }}>
            <Typography variant="body1">
              {weekDayName} | {dateFormat}
            </Typography>
            <Typography variant="caption" sx={{ opacity: 0.5 }}>
              Check it on your google calendar
            </Typography>
          </Box>
        </li>
        <li className="flex items-center">
          <FuseSvgIcon size={40}>heroicons-outline:clock</FuseSvgIcon>
          <Box sx={{ ml: 2 }}>
            <Typography variant="body1">
              {startTime} - {endTime}
            </Typography>
          </Box>
        </li>
        <li className="flex items-center">
          <FuseSvgIcon size={40}>heroicons-outline:location-marker</FuseSvgIcon>
          <Box sx={{ ml: 2, maxWidth: "350px" }}>
            <Typography variant="body1">{reviewDate?.location}</Typography>
          </Box>
        </li>
      </ul>
    </div>
  );
}
